import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { SocialLearningPost, SocialLearningPostComment } from 'src/app/_models';

@Injectable({
  providedIn: 'root'
})
export class SocialLearningService {
  private url: string = environment.apiUrl;
  constructor(private http: HttpClient) {}
  UploadAttachment(file: File) {
    const data = new FormData();
    data.append('File', file);
    return this.http.post(`${this.url}SocialLearning/UploadAttachment`, data);
  }
  RemoveAttachment(id: number) {
    return this.http.delete(`${this.url}SocialLearning/RemoveAttachment/${id}`);
  }
  CreatePost(socialLearningPost: SocialLearningPost) {
    return this.http.post(`${this.url}SocialLearning/CreatePost`, socialLearningPost);
  }
  UpdatePost(socialLearningPost: SocialLearningPost) {
    return this.http.put(`${this.url}SocialLearning/UpdatePost`, socialLearningPost);
  }
  GetPrivatePost(sectionSubejctId: number, pageSize: number, pageIndex: number) {
    return this.http.get(`${this.url}SocialLearning/GetPrivatePost/${sectionSubejctId}/${pageSize}/${pageIndex}`);
  }
  GetPublicPost(sectionSubejctId: number, pageSize: number, pageIndex: number) {
    return this.http.get(`${this.url}SocialLearning/GetPublicPost/${sectionSubejctId}/${pageSize}/${pageIndex}`);
  }
  DeletePost(id: number) {
    return this.http.delete(`${this.url}SocialLearning/DeletePost/${id}`);
  }
  DeActivePostOrReActivePost(postId: number) {
    return this.http.put(`${this.url}SocialLearning/DeActivePostOrReActivePost/${postId}`, null);
  }
  GetLikes(postItemId: number, pageSize: number, pageIndex: number) {
    return this.http.get(`${this.url}SocialLearning/GetLikes/${postItemId}/${pageSize}/${pageIndex}`);
  }
  LikePost(postItemId: number) {
    return this.http.post(`${this.url}SocialLearning/LikePost`, { postItemId });
  }
  DeleteLikePost(postItemId: number) {
    return this.http.delete(`${this.url}SocialLearning/DeleteLikePost/${postItemId}`);
  }
  GetViews(postItemId: number, pageSize: number, pageIndex: number) {
    return this.http.get(`${this.url}SocialLearning/GetViews/${postItemId}/${pageSize}/${pageIndex}`);
  }
  GetComment(postId: number, pageSize: number, pageIndex: number) {
    return this.http.get(`${this.url}SocialLearning/GetComment/${postId}/${pageSize}/${pageIndex}`);
  }
  CreateComment(socialLearningPostComment: SocialLearningPostComment) {
    return this.http.post(`${this.url}SocialLearning/CreateComment`, socialLearningPostComment);
  }
  EditComment(socialLearningPostComment: SocialLearningPostComment) {
    return this.http.put(`${this.url}SocialLearning/EditComment`, socialLearningPostComment);
  }
  DeleteComment(postItemId: number) {
    return this.http.delete(`${this.url}SocialLearning/DeleteComment/${postItemId}`);
  }
  // Start Whatsup
  GetNotePost(pageSize: number, pageIndex: number) {
    return this.http.get(`${this.url}SocialLearning/GetNotePost/${pageSize}/${pageIndex}`);
  }
  // End Whatsup
}
